import Vue from 'vue'
import VueRouter from 'vue-router'
const exceptPaths = ['/login', '/customerVideo']
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
    redirect: '/home',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('../views/Home.vue'),
      }
    ]
  },
  {
    path: '/customerVideo',
    name: 'CustomerVideo',
    component: () => import('../views/CustomerVideo.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
  },
]

const router = new VueRouter({
  routes,
})

// 路由拦截
router.beforeEach((to, from, next) => {
  const userInfo = sessionStorage.getItem('userInfo')
  if (!exceptPaths.includes(to.path) && !userInfo) {
    next({
      path: '/login',
    })
    return
  }
  next()
})
export default router
